import validate from "/opt/bookandgolf-front/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlite3@11.9.1_db0@0.3.1_b_de99e2b912363472fd0b82a59600cdff/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/bookandgolf-front/middleware/auth.global.ts";
import cart_45global from "/opt/bookandgolf-front/middleware/cart.global.ts";
import redirect_45global from "/opt/bookandgolf-front/middleware/redirect.global.ts";
import referer_45global from "/opt/bookandgolf-front/middleware/referer.global.ts";
import manifest_45route_45rule from "/opt/bookandgolf-front/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.3_better-sqlite3@11.9.1_db0@0.3.1_b_de99e2b912363472fd0b82a59600cdff/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  cart_45global,
  redirect_45global,
  referer_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  promotions: () => import("/opt/bookandgolf-front/middleware/promotions.ts")
}